var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M93.75 43.75h-37.5v-37.5h-12.5v37.5h-37.5v12.5h37.5v37.5h12.5v-37.5h37.5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }